import { ClipFragment } from '@src/services/AIClipProducer';
import InfoIcon from '@src/svgs/InfoIconAlt';
import { Tooltip as ReactTooltip } from 'react-tooltip';
import styled from 'styled-components';
import MetricsTooltip from './MetricsTooltip';

export default function ImpactScoreBadge({
  impactScore,
  id, // for tooltip ID
}: {
  impactScore: ClipFragment['impactScore'];
  id: string;
}) {
  if (!impactScore || Object.keys(impactScore).length === 0) {
    return null;
  }

  const { main, ...rest } = destructureImpactScore(impactScore);

  return (
    <Wrapper>
      <BadgeWrapper data-tooltip-id={`${id}-tooltip`} data-tooltip-content="-">
        <Badge>{main}</Badge>
        <IconWrapper>
          <InfoIcon width="12" height="12" />
        </IconWrapper>
      </BadgeWrapper>
      <ReactTooltip
        id={`${id}-tooltip`}
        render={() => (
          <MetricsTooltip
            mainMetric={{ name: 'Impact Score', value: main }}
            otherMetrics={rest}
          />
        )}
        style={{
          background: 'none',
        }}
        place="right-start"
        offset={-30}
      />
    </Wrapper>
  );
}

const Badge = styled.div`
  color: #17c964;
  font-family: Inter;
  font-size: 28px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
`;

const IconWrapper = styled.div`
  color: #848484;
`;

const BadgeWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 2px;
`;

const Wrapper = styled.div`
  z-index: 2;
  --rt-opacity: 1;
`;

function destructureImpactScore(
  impactScore: ClipFragment['impactScore'],
): Record<string, number> {
  if (!impactScore) {
    return { main: 0 };
  }

  let mainKey = Object.keys(impactScore).find(
    (key) =>
      key.toLowerCase().includes('total') ||
      key.toLowerCase().includes('final'),
  );
  if (!mainKey) {
    mainKey = Object.keys(impactScore)[0];
  }

  const rest = Object.keys(impactScore).reduce(
    (acc, key) => {
      if (key !== mainKey) {
        acc[key] = impactScore[key];
      }
      return acc;
    },
    {} as Record<string, number>,
  );

  return { main: impactScore[mainKey], ...rest };
}
